/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const train_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.159 18.375A1.409 1.409 0 0 1 .75 16.966V3a1 1 0 0 1 1-1H11m0 0v8m0-8h1.5M11 10h10.25a2 2 0 0 1 2 2v4.375a2 2 0 0 1-2 2h-.409M11 10H4.5V5.5H11M7 19.25a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm7 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm7 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
    />
  </svg>
)
export default train_medium
